import type { ClosingCTAContent } from '@/content/home';
import { ArrowRight } from '@/components/ui/Icons';

export type ClosingCTAProps = {
  content: ClosingCTAContent;
};

export function ClosingCTA({ content }: ClosingCTAProps) {
  return (
    <section
      aria-labelledby="closing-heading"
      className="bg-ink px-6 py-[140px] md:px-[72px]"
    >
      <div className="mx-auto flex max-w-[1040px] flex-col items-center gap-9 text-center">
        <span className="inline-flex items-center gap-2 rounded-full border border-page/10 bg-page/5 px-3.5 py-1.5">
          <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-cloak-accent" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-page">
            {content.eyebrow}
          </span>
        </span>

        <h2
          id="closing-heading"
          className="text-[36px] font-bold leading-[1.1] tracking-[-1.2px] text-page md:text-[50px]"
        >
          {content.heading}
        </h2>

        <p className="max-w-[760px] text-[16px] leading-[1.55] text-erased md:text-[18px]">
          {content.body}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            href="https://cloakling.dev"
            className="inline-flex items-center gap-2.5 rounded-lg bg-cloak-accent px-[26px] py-4 text-[16px] font-semibold text-page no-underline transition-colors hover:bg-cloak-accent/90"
          >
            {content.primary}
            <ArrowRight size={18} />
          </a>
          <a
            href="mailto:hello@cloakling.com"
            className="inline-flex items-center rounded-lg border border-page/20 px-[26px] py-[15px] text-[16px] font-semibold text-page no-underline hover:bg-page/5"
          >
            {content.secondary}
          </a>
        </div>
      </div>
    </section>
  );
}
